import '@styles/views/csc.less';
/* import AppBannerCSC from '@components/app/appBannerCSC'; */
//import AppAdvantage from '@components/app/appAdvantage';
//import AppDisplayDesc from '@components/app/appDisplayDesc';
import AppFooter from '@components/app/appFooter';
import AppNewTwo from '@/components/app/appNewTwo';

const NewTwo = () => {
  return (
    <div className={'introduce-page'}>
      {/* <AppBannerCSC /> */}
      <AppNewTwo />
      <AppFooter />
    </div>
  );
};

export default NewTwo;
